import { AccountTypeEnum } from './user.model';

/**
 * The digital account API reports account type as 'PERSONAL' | 'BUSINESS', which is a
 * different vocabulary from the `AccountTypeEnum` the app branches on. Verified against
 * QA for both account kinds:
 *
 * | account  | digitalaccounts/{waid} | AccountTypeEnum the app expects              |
 * | -------- | ---------------------- | -------------------------------------------- |
 * | personal | 'PERSONAL'             | 'CUSTOMER'                                   |
 * | business | 'BUSINESS'             | 'COMMERCIAL BUSINESS REPRESENTATIVE' (CFR)   |
 *
 * Business maps to CFR rather than `AccountTypeEnum.Business` because the business route
 * guard, the policy and claim guards, and `selectAccountType`/`selectIsPersonalAccount`
 * all test for CFR specifically. A raw 'BUSINESS' would send a business user down the
 * personal path and bounce them off every /business route.
 *
 * Anything already using the app vocabulary is passed through unchanged, so this is safe
 * to apply to a value from either source. Unrecognized values return undefined so callers
 * keep whatever they already had rather than overwriting it with a meaningless code.
 */
export function normalizeAccountType(code: string | undefined | null): string | undefined {
  switch ((code ?? '').toUpperCase()) {
    case 'PERSONAL':
    case AccountTypeEnum.Customer:
      return AccountTypeEnum.Customer;
    case 'BUSINESS':
    case AccountTypeEnum.CFR:
      return AccountTypeEnum.CFR;
    default:
      return undefined;
  }
}
